#!/usr/bin/env node

import { runCli } from "@/cli/app.ts";

runCli();

